import { render, staticRenderFns } from "./dialogSeparacao.vue?vue&type=template&id=d17cab98&scoped=true"
import script from "./dialogSeparacao.vue?vue&type=script&lang=js"
export * from "./dialogSeparacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17cab98",
  null
  
)

export default component.exports